import React from "react";

export const SubmitButton = () => {
    return (
        <button type="submit" className="interactive-signup-submit-btn">
            Next
        </button>
    );
};
